/**
 * this component is a new version for the save button which was a thin version
 * of the component, now we are not limited to the names of specific function and can allow
 * multiple buttons on the same screen in addition the saving is actually occurring in the component
 * and not on the calling code
 */
baseApp.component('rollingButton', {
    templateUrl: '/public/components/rollingButton.html',
    bindings: {
        preSave: '=?',
        postSave: '=', // post save is mandatory since the user should handle the response
        hasChanges: '=?',
        storeMethod: '@',
        storeConfiguration: '=?',
        label: '@',
        waitLabel: '@',
        saveChanges: '=?',
								extraClass: '@',
								extraDisable: '<'
    },
    controller: rollingButtonConfigurationCtrl
});

/**
 * Created by ronmarsiano on 09/07/2018.
 */
function rollingButtonConfigurationCtrl($scope, $timeout) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.loading = false;

        // for backward compatibility
        if (!ctrl.label && !ctrl.waitLabel) {
            ctrl.label = 'Save';
            ctrl.waitLabel = 'Saving...';
        } else if (!(ctrl.label && ctrl.waitLabel)) {
            ctrl.label = 'label or waitLabel is missing';
            ctrl.waitLabel = 'hmmmm... Working!';
        }

        // for backward compatibility
        if (!ctrl.storeMethod) {
            ctrl.storeMethod = 'save';
        }
    }

    /**
     * return the store configuration for saving
     * @returns {{path, success: success}}
     */
    function getStoreConfiguration() {
        var saveConfiguration = {
            dataObj: 'json',
            success: function (data) {
                $timeout(function() {ctrl.loading = false;}, 0);
                ctrl.postSave(data);
                }};
        if (ctrl.storeConfiguration){
            _.merge(saveConfiguration, ctrl.storeConfiguration())
        }
        return saveConfiguration;
    }

    ctrl.save = function () {
        var isValid = true;
        // if the user specified pre save action
        if (ctrl.preSave){
            isValid = ctrl.preSave();
        }
        if (isValid){
            ctrl.loading = true;
            if (ctrl.saveChanges) {
                ctrl.saveChanges();
            } else {
                var storeConfiguration = getStoreConfiguration();
                store[ctrl.storeMethod](storeConfiguration);
            }
        }
    };

    $scope.$on('stop-load', function() {
        $timeout(function() {ctrl.loading = false;}, 0);
    });
};

